import { useQuery } from "@tanstack/react-query";
import { fetchLocationOverview } from "./locationAPI";

export const useLocationOverview = () => {
    return useQuery({
        queryKey: ["locationOverview"],
        queryFn: fetchLocationOverview,
    });
};
